<fieldset class="select-area">
    <legend *ngIf="title">{{ title }}</legend>
    <div class="options" >
        <span *ngFor="let option of options">
            <ng-container [ngTemplateOutlet]="formControl ? inputFormControl : simpleInput" 
                [ngTemplateOutletContext]="{option: option}">
            </ng-container>
            <label [for]="option.id">{{ option.label }}</label>
        </span>
    </div>    
</fieldset>

<ng-template #simpleInput let-option="option">
    <input type="radio" [id]="option.id" [disabled]="option.disabled"
        [value]="option.id" [checked]="option.selected" 
        (change)="onSelect(option)">
</ng-template>

<ng-template #inputFormControl let-option="option">
    <input type="radio" [formControl]="formControl" [class.invalid]="formControl.invalid && formControl.dirty"
        [id]="option.id" [value]="option.id" [checked]="option.selected"
        (change)="onSelect(option)">
</ng-template>